<div class="text-center">
    <img class="img-fluid centerFix"
        [src]="'loading_image_microapp' | translate | link"
        alt="'loading_image_alt_microapp' | translate"
        role="presentation"
        aria-hidden="true">
  </div>

